import defaultOrganizerAvatarSrc from "./assets/default/avatar-organizer-default.png";
import defaultPlayerAvatarSrc from "./assets/default/avatar-player-default.png";
import defaultTournamentBannerSrc from "./assets/default/banner default.png";
import greenMebiLogoSmallCircleSrc from "./assets/default/Green_Mebi_Logo_small_circle.png";
// Diagnostic: logo-app.png import removed to rule out decode stalls on Android WebView
// import logoAppSrc from "./assets/default/logo-app.png";
import defaultProfileBackgroundSrc from "./assets/default/profile-background-default.png";

type AssetImport = string | { src: string };

const toAssetSrc = (asset: AssetImport): string =>
  typeof asset === "string" ? asset : asset.src;

export const DEFAULT_ORGANIZER_AVATAR_SRC = toAssetSrc(
  defaultOrganizerAvatarSrc,
);
export const DEFAULT_PLAYER_AVATAR_SRC = toAssetSrc(defaultPlayerAvatarSrc);
export const DEFAULT_TOURNAMENT_BANNER_SRC = toAssetSrc(
  defaultTournamentBannerSrc,
);
export const DEFAULT_PROFILE_BACKGROUND_SRC = toAssetSrc(
  defaultProfileBackgroundSrc,
);
export const GREEN_MEBI_LOGO_SMALL_CIRCLE_SRC = toAssetSrc(
  greenMebiLogoSmallCircleSrc,
);
export const APP_LOGO_SRC = "";
